module.exports = __webpack_public_path__ + "img/Rookie-2.ae2d229e.png";